










import { platform, Bridge } from '@/common/bridge';
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import BubbleIcon from './icons/BubbleIcon.vue';

const chatModule = namespace('chat');

@Component({ components: { BubbleIcon } })
export default class FloatButton extends Vue {
  @chatModule.State('hasNewMessage') hasNewMessage!: boolean;
  isPC = platform === 'web';

  get containerClass () {
    return this.hasNewMessage ? 'container__new-msg' : 'container';
  }

  openHelp () {
    Bridge.maximize();
  }
}
